import { date } from "./app";
import { multiple } from "../utils";
import { i18n } from "@/services/vue-i18n";

export var user = usr => {
  return new Promise(resolve => {
    var adapted = usr;
    // Build the role's data
    if (
      usr.role === "student" ||
      usr.role === i18n.t("user.roles.student.title")
    ) {
      student(adapted).then(st => (adapted = st));
    } else {
      if (
        adapted.role === "teacher" ||
        adapted.role === i18n.t("user.roles.teacher.title")
      ) {
        teacher(adapted).then(tc => (adapted = tc));
      }
    }
    resolve(adapted);
  });
};

/**
 * Adapt data for a new user about to be created.
 * @param { Object } usr The user's data
 */
export var newUser = usr => {
  return new Promise(resolve => {
    var adapted = usr;
    if (adapted.role === i18n.t("user.roles.student.title")) {
      adapted.student = {
        age: adapted.age
      };
    }
    if (adapted.role === i18n.t("user.roles.teacher.title")) {
      adapted.teacher = {
        is_admin: adapted.admin
      };
    }
    delete adapted.age;
    delete adapted.is_admin;

    user(adapted).then(res => {
      resolve(res);
    });
  });
};

export var student = st => {
  return new Promise(resolve => {
    var adapted = {};
    if (st.student.age) {
      const age = parseInt(st.student.age);
      adapted.student = {
        id: st.student.id,
        age: age,
        notice: st.student.notice
      };
    } else {
      adapted.student = {};
    }
    resolve(adapted);
  });
};

export var teacher = tc => {
  return new Promise(resolve => {
    var adapted = {};
    adapted.teacher = {
      id: tc.teacher.id,
      is_admin: tc.teacher.is_admin ? 1 : 0
    };
    delete adapted.is_admin;
    resolve(adapted);
  });
};

export var users = list => {
  return multiple(list, user);
};

const adapters = {
  user,
  users,
  newUser,
  student,
  teacher
};

export default adapters;
